export default __webpack_public_path__ + "static/media/a012-7.02d1a84c.svg";